import React, { useState, useEffect } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableVirtuoso } from 'react-virtuoso';
import { useParams, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { getRateSingleView } from "../rates/ratesAction";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useSelector, useDispatch } from "react-redux";
import { FaEdit, FaTrash, FaPlus, FaEye,FaArrowLeft } from 'react-icons/fa';
import { makeStyles } from '@mui/styles';
import { CSSProperties } from '@mui/system';



// Function to merge the base data with child, infant, and adult rates
function mergeData(baseData, childData, infantData, adultData,supplementData,promotionData,hourData,vehicleData) {
  // Create a new array to hold the merged data
  const mergedData = [];

  // Loop through the baseData array
  for (const baseItem of baseData) {
    // Find all the corresponding child, infant, and adult data using the IDs (base_product_id)
    const childItems = childData.filter((item) => item.base_product_id === baseItem.id);
    const infantItems = infantData.filter((item) => item.base_product_id === baseItem.id);
    const adultItems = adultData.filter((item) => item.base_product_id === baseItem.id);
    const supplementItems = supplementData.filter((item) => item.base_product_id === baseItem.id);
    const promotionItems = promotionData.filter((item) => item.base_product_id === baseItem.id);
    const hourItems = hourData.filter((item) => item.base_product_id === baseItem.id);
    const vehicleItems = vehicleData.filter((item) => item.base_product_id === baseItem.id);

    // Merge the data into a single object
    const mergedItem = {
      ...baseItem,
      child: childItems.length > 0 ? [...childItems] : null,
      infant: infantItems.length > 0 ? [...infantItems] : null,
      adult: adultItems.length > 0 ? [...adultItems] : null,
      supplement: supplementItems.length > 0 ? [...supplementItems] : null,
      promotion: promotionItems.length > 0 ? [...promotionItems] : null,
      hour: hourItems.length > 0 ? [...hourItems] : null,
      vehicle: vehicleItems.length > 0 ? [...vehicleItems] : null,
    };

    // Push the merged item to the mergedData array
    mergedData.push(mergedItem);
  }

  return mergedData;
}

  
const useStyles = makeStyles((theme) => ({
  stickyHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#1f3c3b',
    color: 'white',
    fontWeight: '600',
    zIndex: 1000, // Custom zIndex value, adjust as needed
  },
}));

export default function RatesSingleView() {
  const { name } = useParams();
  const navigate = useNavigate();
  const {pid} = useParams();
  const {pname} = useParams();
  const { SubProductId } = useParams();
  const dispatch = useDispatch();
  
  const classes = useStyles();


  useEffect(() => {
    dispatch(getRateSingleView(SubProductId));
  }, []);
  const onBack = () => {
   

        navigate('/SubproductListId/' + pid + "/" +pname); 

   
 }

  const base = useSelector((state) => state.productratesList?.rates?.base || []);
  const adult = useSelector((state) => state.productratesList?.rates?.adult || []);
  const child = useSelector((state) => state.productratesList?.rates?.child || []);
  const infant = useSelector((state) => state.productratesList?.rates?.infant || []);
  const supplement = useSelector((state) => state.productratesList?.rates?.supplement || []);
  const promotion = useSelector((state) => state.productratesList?.rates?.promotion || []);
  const hour = useSelector((state) => state.productratesList?.rates?.hour || []);
  const vehicle = useSelector((state) => state.productratesList?.rates?.vehicle || []);

  // Merge the data from the different datasets
  const mergedRows = mergeData(base, child, infant, adult,supplement,promotion,hour,vehicle);
  console.log("dhfhdhhdfhhdf",mergedRows)

  return (
    <Paper style={{ height: '100%', width: '100%', marginBottom: '122px',marginTop:'59px',marginRight:'229px',marginLeft:'19px', padding: '16px' }}>
      
      <h4 style={{ fontWeight: '500', textAlign: 'center', marginTop: '-100px',fontFamily:'Times new roman', fontWeight:'600' }}><u>View All {name} Rates:</u></h4>
      <span className="badge bg-success" onClick={onBack} style={{ backgroundColor: 'rgb(156 186 237)', color: 'white', cursor: 'pointer' ,marginTop:'-100px'}}><FaArrowLeft />&nbsp;Go Back</span>
      <br />  <br />
    
<br />
    {/* <div style={{ position: 'sticky', top: '60px', zIndex: 1 ,width:'100%'}}> */}
    {/* <div style={{ height: '400px', overflow: 'auto' }}> */}
    <TableContainer component={Paper} style={{ height: '400px', overflow: 'auto' }}>
      <Table sx={{ minWidth: 650 }} aria-label="universal table header">
        <TableHead>
          <TableRow>
          <TableCell  style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>From Date - To Date</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>From Age</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>To Age</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Mon</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Tue</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Wed</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Thu</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Fri</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Sat</TableCell>
            <TableCell align="center" style={{fontWeight:'600',backgroundColor:'#1f3c3b',color:'white'}} className={classes.stickyHeader}>Sun</TableCell>
          </TableRow>
        </TableHead>
      
        <TableBody>
          {mergedRows.map((item, index) => (
            <React.Fragment key={index}>
              <TableRow style={{backgroundColor:'#38565d'}}>
                <TableCell colSpan={10} style={{color:'white',fontWeight:'bold'}}>{item?.from_date} - {item?.to_date}&nbsp;{item?.status == 'Rejected' ?<> <span className="badge bg-danger" style={{ backgroundColor: 'red', color: 'white'}}>&nbsp;Rejected</span></> : item?.status == 'Approved' ? <><span className="badge bg-success" style={{ backgroundColor: 'green', color: 'white'}}>&nbsp;Approved</span></> : <><span className="badge bg-warning" style={{ backgroundColor: 'yellow', color: 'white'}}>Pending</span>
     </>}</TableCell>
              </TableRow>
              {/* Render table for "hour" data of the current item */}
              {item.hour ? item.hour.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell  style={{fontWeight:'600'}}>Hourly Rates</TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.monday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.tuesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.wednesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.thursday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.friday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.saturday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.sunday}</TableCell>
                </TableRow>
              )) : ""}

                {/* Render table for "vehicle" data of the current item */}
                {item.vehicle ? item.vehicle.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell  style={{fontWeight:'600'}}>Vehicle Rates</TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.monday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.tuesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.wednesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.thursday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.friday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.saturday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.sunday}</TableCell>
                </TableRow>
              )) : ""}




              {/* Render table for "adult" data of the current item */}
              {item.adult ? item.adult.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell  style={{fontWeight:'600'}}>Adult Rates</TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.monday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.tuesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.wednesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.thursday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.friday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.saturday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.sunday}</TableCell>
                </TableRow>
              )) : ""}
              {/* Render table for "child" data of the current item */}
              {item.child ? item.child.map((row) => (
                <TableRow  hover key={row.id}>
                  <TableCell  style={{fontWeight:'600'}}>Child Rates</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.from_age}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.to_age}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.monday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.tuesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.wednesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.thursday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.friday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.saturday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.sunday}</TableCell>
                </TableRow>
              )): ""}
              {/* Render table for "infant" data of the current item */}
              {item.infant ? item.infant.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell  style={{fontWeight:'600'}}>Infant Rates</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.from_age}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.to_age}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.monday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.tuesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.wednesday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.thursday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.friday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.saturday}</TableCell>
                  <TableCell align="center" style={{fontFamily:'Bahnschrift Condensed'}}>{row?.sunday}</TableCell>
                </TableRow>
              )):""}
              {item.supplement  && <> <TableRow>
                <TableCell colSpan={2} align="center" style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}></TableCell>
                <TableCell colSpan={2} align="center" style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>From Date</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>To Date</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>Supplement Rate</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>AddOn Rate</TableCell>
              </TableRow></>}
             

              {item.supplement ? item.supplement.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell style={{ fontWeight: '600' }} colSpan={2}>Supplement Rates</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.start_date}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.end_date}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.discount_type}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.discount}</TableCell>
                 
                </TableRow>
              )) : ""}



              {item.promotion && <> <TableRow>
                <TableCell colSpan={1} align="center" style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}></TableCell>
                <TableCell colSpan={1} align="center" style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>From Date</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>To Date</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>Discount Type</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>Discount Rate</TableCell>
                <TableCell align="center" colSpan={2} style={{ fontWeight: '600', backgroundColor: '#38565d', color: 'white' }}>Offer Code</TableCell>
              </TableRow></>}


              {item.promotion ? item.promotion.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell style={{ fontWeight: '600' }} colSpan={1}>Promotion Rates</TableCell>
                  <TableCell align="center" colSpan={1} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.start_date}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.end_date}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.discount_type}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.discount}</TableCell>
                  <TableCell align="center" colSpan={2} style={{ fontFamily: 'Bahnschrift Condensed' }}>{row?.offer_code}</TableCell>

                </TableRow>
              )) : ""}

             
            </React.Fragment>
          ))}
        </TableBody>
        </Table>
    </TableContainer>
    {/* </div> */}
  
 
  </Paper>
  );
}
